import type { MeResponse, StatusResponse } from '@brimstone/shared';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { ApiError, api } from './api';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Client errors (401, 404, …) won't change on retry.
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      },
    },
  });
}

export const queryKeys = {
  me: ['me'] as const,
  status: ['status'] as const,
  watcherTokens: ['watcher-tokens'] as const,
};

export function useMe() {
  return useQuery({ queryKey: queryKeys.me, queryFn: () => api<MeResponse>('/api/me') });
}

export function useStatus() {
  return useQuery({
    queryKey: queryKeys.status,
    queryFn: () => api<StatusResponse>('/api/status'),
    refetchInterval: 60_000,
  });
}
